import React from 'react';
import { twMerge } from 'tailwind-merge';
import { colorStyle, colorBgStyles } from '../../utils';

export const ColorBackground = (props) => {
  const bgColor = colorStyle(props.color);

  return (
    <div className="color-background relative mb-0 mt-0 h-full bg-[#131056] bg-transparent last:mb-0 first-of-type:-mt-44 first-of-type:pt-10 last-of-type:mb-20 last-of-type:pb-20 md:first-of-type:-mt-12 [&:first-of-type>*]:pt-44 md:[&:first-of-type>*]:pt-0">
      <div
        className={twMerge(
          'not-prose absolute left-[50%] right-[50%] z-10 -mx-[50vw] h-full w-[100vw] transform-none md:left-0 md:right-0 md:mx-0 md:-translate-x-[20.27%] xl:left-[57.8%] xl:right-[42.2%] xl:-mx-[50vw] xl:transform-none',
          bgColor
        )}
      ></div>
      <div
        className={
          bgColor === 'bg-white'
            ? twMerge(
                colorBgStyles.lightBackgroundStyle,
                colorBgStyles.paraStyle,
                colorBgStyles.firstHeaderStyle
              )
            : twMerge(
                colorBgStyles.darkBackgroundStyle,
                colorBgStyles.caseStudyStyle,
                colorBgStyles.detailsStyle,
                colorBgStyles.paraStyle,
                colorBgStyles.firstHeaderStyle,
                colorBgStyles.relatedArticleStyle
              )
        }
      >
        {props.children}
      </div>
    </div>
  );
};
